module.exports = __webpack_public_path__ + "media/PeeledOrange_Mobile.810b935d.mp4";